import React, { useState } from "react";
import { getConnectInboxCsvErrorLabel } from "./constants";

const i = n => `${n} ${n === 1 ? "inbox" : "inboxes"}`;

const BulkCsvResultBody = ({ successCount = 0, failedCount = 0, failedRows = [] }) => {
  const [showMore, setShowMore] = useState(false);

  if (failedCount === 0) {
    return <div>All inboxes are connected successfully.</div>;
  }

  const headline =
    successCount === 0
      ? `Failed to connect all inboxes. `
      : `${i(successCount)} connected successfully. Failed to connect ${i(failedCount)}. `;

  return (
    <div>
      <span>{headline}</span>
      <span className="linkHighLight" onClick={() => setShowMore(!showMore)}>
        {showMore ? "View less" : "View more"}
      </span>
      {showMore && (
        <div className="failureResponseMsg" style={{ textAlign: "left" }}>
          <div className="leftBorder" />
          {failedRows.map(row => (
            <div key={row.email}>{`${row.email} — ${getConnectInboxCsvErrorLabel(row)}`}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BulkCsvResultBody;
export { BulkCsvResultBody };
